import React, { useState } from 'react';
import CustomAssignedItems from '../../../../../../../components/CustomAvailableAssignedItems/CustomAssignedItems';
import AssignedSectionTitle from '../../../../../../../components/CustomAvailableAssignedItems/SubComponents/AssignedSectionTitle';
import { VIEW_TYPE } from '../../../../../../../enums/ViewType';
import { AssignedDeductionApp } from '../Functionality/AssignedDeductionApp';
import { SEARCH_MODEL } from '../../../../../../../components/table/Model/TableModel';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @Description Read-only expanded section for one resource of a user deduction policy.
 * Follows the ShiftAccess RenderDetails pattern. Owns all state via AssignedDeductionApp.
 */

const UserDeductionRenderAssignedSection = ({ resource, id, userId, title, Icon, tableNotInformationLegend}) => {
    const [selectForDelete, setSelectForDelete] = useState([]);

    const {
        results, setResults,
        setBodyForExport,
        searchElement, setSearchElement,
        setSearch,
        setSimpleSearch,
        modified, setModified,
        isAllChecked, setIsAllChecked,
        dynamicConfig
    } = AssignedDeductionApp({
        resource,
        id,
        userId,
        tableNotInformationLegend
    });

    return (
        <div className="px-3 pb-3">
            <CustomAssignedItems
                setBodyForExport={setBodyForExport}
                results={results}
                setResults={setResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                setSearch={setSearch}
                setSimpleSearch={setSimpleSearch}
                modified={modified}
                setModified={setModified}
                selected={selectForDelete}
                setSelected={setSelectForDelete}
                labelRowsPerPage={dynamicConfig?.labelRowsPerPage}
                tableNotInformationLegend={dynamicConfig?.tableNotInformationLegend}
                tableBuildBody={({ page, rowsPerPage, searchElement }) => ({ body: SEARCH_MODEL.setObject({
                        page: page,
                        size: rowsPerPage,
                        key: searchElement,
                        model: dynamicConfig?.model,
                        modelId:  dynamicConfig?.modelId,
                        userId: dynamicConfig?.userId,
                    }) })}
                tableEndPoint={dynamicConfig?.endPoint}
                keyId={dynamicConfig?.keyId}
                viewTypeName={VIEW_TYPE.GRID.name}
                isAllChecked={isAllChecked}
                setIsAllChecked={setIsAllChecked}
                onDelete={undefined}
                checkbox={false}
                searchLabel={dynamicConfig?.searchLabel}
                renderAssignedItem={dynamicConfig?.renderAssignedItem}
                renderModuleTitle={<AssignedSectionTitle Icon={Icon} title={title} />}
                autoHeight={false}
            />
        </div>
    );
};

export default UserDeductionRenderAssignedSection;
